module.exports = __webpack_public_path__ + "static/media/Mytraining-icon.a9294031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/Mytraining-icon.svg
// module id = 1844
// module chunks = 27